import { BaSeParagraph, BaSeTheme } from '@base/react';
import styled from 'styled-components';
import bannerEmpretec from '../assets/banner-empretec.png';
import btAccess from '../assets/button-home.png';
import graphTextHome from '../assets/graph-text-home.png';
import manHome from '../assets/man-home.png';

export const ContainerHome = styled.div`
  height: max(1103px, 100vh);
  background-color: ${BaSeTheme.colors.defaultColors.black};
  display: flex;
  justify-content: center;

  &::before {
    position: fixed;
    content: '';
    width: 100vw;
    height: 100vh;
    display: block;
    bottom: 0;
    left: 0;
    background: radial-gradient(
      circle at bottom left,
      #5c0936 0%,
      transparent 40vw
    );
  }
`;

export const Background = styled.div`
  position: relative;
  width: 100vw;
  max-width: ${BaSeTheme.breakpoints.desktop.maxWidth}px;
  height: max(1103px, 100vh);
  position: absolute;
  background: url(${manHome}) no-repeat left 30px top 0px,
    url(${graphTextHome}) no-repeat left 80px top -60px,
    url(${bannerEmpretec}) no-repeat right 100px top 850px;

  &::before {
    content: '';
    position: absolute;
    width: ${BaSeTheme.breakpoints.desktop.maxWidth}px;
    border: none;
    height: 1px;
    background-color: rgba(240, 246, 254, 0.5);
    left: 0px;
    top: 1039px;
  }
`;

export const ButtonAccess = styled.div`
  position: absolute;
  background: url(${btAccess});
  cursor: pointer;
  width: 223px;
  height: 40px;
  left: 778px;
  top: 550px;

  &:hover {
    box-shadow: 0px 0px 5px 0px #ff1493;
  }
`;

export const InfoText = styled.div`
  position: absolute;
  padding-right: 100px;
  max-width: ${({ maxWidth }) => maxWidth}px;
  min-height: 140px;
  left: 778px;
  top: ${({ top }) => top}px;
  gap: ${({ gap }) => gap}px;
`;

export const TextAccess = styled.div`
  padding-bottom: 20px;
`;

export const TextGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const LinkAqui = styled(BaSeParagraph)`
  cursor: pointer;
`;

export const WrapperLink = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
`;
